import { NotifyHelper } from "../../../helpers/toast";
import { eTienDoNhapDiemLopTinChiActionsObj } from "../../action-types/tong-hop/ITienDoNhapDiemLopTinChiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const tienDoNhapDiemLopTinChiActions = {
    ...generateActions(eTienDoNhapDiemLopTinChiActionsObj, "TIEN_DO_NHAP_DIEM_LOP_TIN_CHI"),
    ...generateActionForKey(eTienDoNhapDiemLopTinChiActionsObj, "TIEN_DO_NHAP_DIEM_LOP_TIN_CHI","THANH_PHAN_LOAD_SUCCESS", () => { NotifyHelper.Success("Tổng hợp thành công") }),
    ...generateActionForKey(eTienDoNhapDiemLopTinChiActionsObj, "TIEN_DO_NHAP_DIEM_LOP_TIN_CHI","THANH_PHAN_LOAD_ERROR", (m) => { NotifyHelper.Error(m) }),

}